angular.module('impactx.event').directive('ixResizeDetection', function ($parse) {
    return {
        restrict: 'A',
        link: postLink
    };

    function postLink(scope, element, attrs) {
        scope.$watch(function () {
            return element.width();
        }, function (newValue, oldValue) {
            if (!angular.equals(newValue, oldValue)) {
                scope.$applyAsync(function () {
                    var resizeFunction = $parse(attrs.ixResizeDetection);
                    resizeFunction(scope, {$event: event});
                });
            }
        });
    }
});